import { DatePipe } from "@angular/common";
import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { memoize } from "lodash";

const genericDateFormatter = (value) => {
    if (!value) {
        return value;
    }

    const dateValue = new Date(value);
    return new Date(dateValue.getUTCFullYear(),
        dateValue.getUTCMonth(),
        dateValue.getUTCDate(),
        dateValue.getUTCHours(),
        dateValue.getUTCMinutes(),
        dateValue.getUTCSeconds());
};

const _utcFormatter = (value, format, locale) => {
    const datewithouttimezone = genericDateFormatter(value);
    return new DatePipe(locale).transform(datewithouttimezone, format);
};
const _objectFormatter = (value) => {
    const datewithouttimezone = genericDateFormatter(value);
    return new Date(datewithouttimezone);
};
const utcFormatter = memoize(_utcFormatter, (...args) => args.join());
const objectFormatter = memoize(_objectFormatter, (...args) => args.join());

@Pipe({
    name: "formattedDate",
    pure: true,
})
export class UTCFormattedDatePipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private locale) {
    }

    public transform(value, format: string): any {
        if (!value) {
            return value;
        }
        return utcFormatter(value, format, this.locale);
    }
}

@Pipe({
    name: "utcDateObj",
    pure: true,
})
export class UTCDateObjectPipe implements PipeTransform {

    public transform(value: any): any {
        if (!value) {
            return value;
        }
        return objectFormatter(value);
    }
}
